export default "__VITE_ASSET__BZII8NEN__";